// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var CustomFieldsDialogController = function ($scope, $modalInstance, customFieldSettings, customFields) {
    $scope.customFieldSettings = customFieldSettings;
    $scope.customFields = customFields;

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.ok = function () {
        $modalInstance.close($scope.model.resultValue);
    };
};

CustomFieldsDialogController.$inject = ['$scope', '$uibModalInstance', 'customFieldSettings', 'customFields'];
